import {useEffect} from "react";
import {appStore} from "./app.store";


export const useApp = () => {
    const {isAppInitialized, initializeApp, cancelAppInitialization} = appStore

    useEffect(() => {
        initializeApp()

        return () => {
            cancelAppInitialization()
        }
    }, []);

    return {isAppInitialized}
}